import { useEffect } from 'react';
import FetchSignal from './fetchSignal';

const ESSENTIAL_EVENT_AVAILABLE = 'ResyUCMEssentialCookieScript_loaded';
const MARKETING_EVENT_AVAILABLE = 'ResyUCMMarketingCookieScript_loaded';

/**
 * When EssentialScript triggers, the BAU (Business As Usual) flow will start.
 */
const handleEssentialScriptEvent = () => {
  if (typeof window === 'undefined' || !window.fetchSignal) return;

  window.fetchSignal.signalBAU();
};

/**
 * Handles MarketingScriptEvent by triggering offer flow.
 * This will abort any active API calls and emit a signal with offer = true.
 */
const handleMarketingScriptEvent = () => {
  if (typeof window === 'undefined' || !window.fetchSignal) return;

  window.fetchSignal.signalOffer();
};

/**
 * Initializes the FetchSignal instance and sets up event listeners.
 * Listens to:
 * - EssentialScriptEvent: triggers BAU flow (non-offer)
 * - MarketingScriptEvent: triggers offer flow
 *
 * The signals emitted can be consumed by child holocrons via:
 * window.fetchSignal.onSignalReady(handler)
 */
export const initFetchSignal = () => {
  if (typeof window === 'undefined') return;

  // Create singleton FetchSignal instance
  if (!window.fetchSignal) {
    window.fetchSignal = new FetchSignal();
  }
};

export const useRootSignalListeners = () => {
  useEffect(() => {
    /* istanbul ignore next */
    if (typeof window === 'undefined') return () => {};

    // Initialize fetchSignal and set up event listeners
    initFetchSignal();

    // Set up event listeners for EssentialScriptEvent and MarketingScriptEvent
    window.addEventListener(ESSENTIAL_EVENT_AVAILABLE, handleEssentialScriptEvent);
    window.addEventListener(MARKETING_EVENT_AVAILABLE, handleMarketingScriptEvent);

    // Clean up event listeners on unmount
    return () => {
      window.removeEventListener(ESSENTIAL_EVENT_AVAILABLE, handleEssentialScriptEvent);
      window.removeEventListener(MARKETING_EVENT_AVAILABLE, handleMarketingScriptEvent);
    };
  }, []);
};
